import {PlayerColor} from '@colonist/game-states'
import {ImageURL} from '@colonist/types'
import CityWallRed from '@static/images/city_wall_red.svg'
import CityWallBlue from '@static/images/city_wall_blue.svg'
import CityWallOrange from '@static/images/city_wall_orange.svg'
import CityWallGreen from '@static/images/city_wall_green.svg'
import CityWallBlack from '@static/images/city_wall_black.svg'
import CityWallBronze from '@static/images/city_wall_bronze.svg'
import CityWallSilver from '@static/images/city_wall_silver.svg'
import CityWallGold from '@static/images/city_wall_gold.svg'
import CityWallWhite from '@static/images/city_wall_white.svg'
import CityWallPurple from '@static/images/city_wall_purple.svg'
import CityWallMysticBlue from '@static/images/city_wall_mysticblue.svg'
import CityWallPink from '@static/images/city_wall_pink.svg'

export const CITY_WALL_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: CityWallRed,
    [PlayerColor.Blue]: CityWallBlue,
    [PlayerColor.Orange]: CityWallOrange,
    [PlayerColor.Green]: CityWallGreen,
    [PlayerColor.Black]: CityWallBlack,
    [PlayerColor.Bronze]: CityWallBronze,
    [PlayerColor.Silver]: CityWallSilver,
    [PlayerColor.Gold]: CityWallGold,
    [PlayerColor.White]: CityWallWhite,
    [PlayerColor.Purple]: CityWallPurple,
    [PlayerColor.MysticBlue]: CityWallMysticBlue,
    [PlayerColor.Pink]: CityWallPink,
}
